import { render, staticRenderFns } from "./RecenteBerichten.vue?vue&type=template&id=026bd404"
import script from "./RecenteBerichten.vue?vue&type=script&lang=js"
export * from "./RecenteBerichten.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports